import "./style.css"

export default function Footer(){
  return(
    <div className="footer-container">
      <span>&copy; Todos os direitos reservados</span>
    </div>
  );
};